import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import ReactJson from "react-json-view";
import { RouteComponentProps } from "react-router-dom";
import { IProject, IApplicationState } from "../../../../models/applicationState";

export interface IJsonResponseProps extends RouteComponentProps, React.Props<JsonResponse> {
    project?: IProject;
    jsonData: any;
    export?: boolean;
    outPutFormat: string;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
    };
}

export interface IJsonResponsesState { }

@connect(mapStateToProps)

export default class JsonResponse
    extends React.Component<IJsonResponseProps, IJsonResponsesState> {
    public render() {
        return (
            <>
                <div className="card shadow">
                    {/*!this.props.export &&
                        <div className="text-center train-sce">
                            <Link to={`projects/${this.props.match.params["projectName"]}/${this.props.match.params["projectId"]}/edit`} type="button" className="btn btn-sm">
                                <i className="fa-file-export" aria-hidden="true"></i>  Export</Link>
                    </div>*/}
                   {/* <div className="card-header">
                        {this.props.outPutFormat ? `${this.props.outPutFormat}` : "JSON Response"}
                    </div>*/}
                    <div className="wrap-test-right-sec"  >
                        {this.props.jsonData ?
                            <ReactJson theme="bright"
                                iconStyle="square"
                                collapsed={true}
                                src={this.props.jsonData}
                            /> : <Spinner
                                label="Loading JSON"
                                ariaLive="off"
                                className="loading" size={SpinnerSize.large} />}
                    </div>
                </div>
            </>
        );
    }
}
